module.exports = __webpack_public_path__ + "img/mask.aa4aa1c4.png";